<button *ngIf="!config?.type" class="talk-to-us-btn" [ngClass]="buttonClass? buttonClass: ''" mat-raised-button (click)="openDialogTalkToUs()" [ngStyle]="{'width': width, 'height': height}">
    {{title}}
</button>

<button *ngIf="config?.type?.match('v1')" class="talk-to-us" [ngClass]="config?.type" (click)="openDialogTalkToUs()" mat-raised-button>
  <div class="card">
    <div class="cont">
      <em class="material-icons">perm_phone_msg</em>
      <div class="content">
        <div class="head">Talk to Us</div>
        <div class="title">Resolve all your queries with Ketto</div>
      </div>
    </div>
    <em class="material-icons">keyboard_arrow_right</em>
  </div>
</button>